export default __webpack_public_path__ + "logo-7e9c2ec946a933a57d3c97c6563723cb.png";